import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import { Row,Col, Card, Form, Button, InputGroup, Modal} from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase, momentDate
} from '../../../utils';
import {Api} from '../../../utils/Variables';
import axios from 'axios';
import { message, Tooltip, Spin, Switch,}  from 'antd';

import PsContext from '../../context/PsContext';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 8 },
};

class AddCollectionEntry extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			showLoader: false,
			showCustomerSerach: false,
			isMorning: parseInt(momentDate((new Date()),'H'))>parseInt('12') ? false : true,
			customers: [],
			customerView: [],
			selectedCustomer: [],
			totalLitters: '',
			totalWeight: '',
			rate: '',
			totalAmount: '',
			totalFat: '',
			totalLr: '',
			totalSnf: '',
		}
		
		this.handleShiftChange = this.handleShiftChange.bind(this);
		this.handleCustomerSearchClick = this.handleCustomerSearchClick.bind(this);
		this.handleCustomerSearchClose = this.handleCustomerSearchClose.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleCustomerSelect = this.handleCustomerSelect.bind(this);
		this.handleWeightChange = this.handleWeightChange.bind(this);
		this.handleFatChange = this.handleFatChange.bind(this);
		this.handleLrChange = this.handleLrChange.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	}
	
	resetState(){
		this.setState({
			selectedCustomer: [],
			totalLitters: '',
			totalWeight: '',
			rate: '',
			totalAmount: '',
			totalFat: '',
			totalLr: '',
			totalSnf: '',
		});
	}
	
	componentDidMount(){
		
		this.context.updateHeader({
			top: false,
			title: 'Collection Entry',
			back: true,
		});
		this.loadData();
	}
	
	componentWillUnmount(){
		
		this.context.updateHeader({top: false});		
	}
	
	loadData(){
		try{
			this.setState({
				dataView: [],
				dataList: [],
				showLoader: true,
			});
			axios.get(Api.Url+'v1/customers?api='+this.context.state.api).then(res=>{
				if(res['data'].status=='1'){
					this.setState({
						customers: res['data'].data,				
						customerView: res['data'].data,				
					});
				}
				this.setState({showLoader: false});
			});
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	handleCustomerSearchClick(){
		this.setState({
			showCustomerSerach: true
		});
	}
	
	handleCustomerSearchClose(){
		this.setState({
			showCustomerSerach: false,
			customerView: this.state.customers,
		});
	}
	
	handleFormSubmit(e){
		e.preventDefault();
		try{
			
			if(!window.confirm('Do you want to save?')){
				return;
			}
			
			this.setState({showLoader: true});
			 axios.post(Api.Url+'v1/collection/new', $("#frmCollection_Entry").serialize()).then(res=>{
				if(res['data'].status=='1'){
					document.getElementById("frmCollection_Entry").reset();
					message.success(res['data'].message || 'Success');
					this.setState({showLoader: false});
					this.resetState();
				}	
				else{
					message.error(res['data'].message || 'Error');
					this.setState({showLoader: false});
				}
			 });
			
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	
	
	handleShiftChange(e){
	
		this.setState({
			isMorning: e ? 'Morining' : 'Evening',
		});
	}
	
	handleCustomerSelect(item){
		
		this.setState({
			selectedCustomer: item,
			showCustomerSerach: false,
		});
		
	}
	
	handleWeightChange(e){
		try{
			var weight = e.target.value;
			var lit = (parseFloat(weight)/ 1.03).toFixed(1);
			
			this.setState({
				totalWeight: weight,
				totalLitters: lit,
			});
			
			this.updateRate();
		}
		catch(error){}
	}
	
	handleFatChange(e){
		
		this.setState({
			totalFat: e.target.value,
		});
		this.state.totalFat = e.target.value;
		//console.log(this.state.totalFat);
		this.calculateSnf();
		
	}
	
	handleLrChange(e){
		
		this.setState({
			totalLr: e.target.value,
		});
		this.state.totalLr = e.target.value;
		//console.log(this.state.totalLr);
		this.calculateSnf();
		
	}
	
	calculateSnf(){
		try{
			
			var snf = ( (parseFloat(this.state.totalLr)/4) + (0.20 * parseFloat(this.state.totalFat)) + 0.36).toFixed(2);
			this.setState({
				totalSnf: snf
			});
			
			this.updateRate();
		}
		catch(error){ console.log(error); }
	}
	
	updateRate(){ 
		try{
			var ts = this.context.state.company.ts_value;
			/* console.log('Fat : '+(parseFloat(this.state.totalFat)));
			console.log('Snf : '+(parseFloat(this.state.totalSnf)));
			console.log('Ts : '+(parseFloat(ts)));
			console.log('------------------------'); */
			var rate = ( (parseFloat(this.state.totalFat) + parseFloat(this.state.totalSnf)) * parseFloat(ts)).toFixed(2);
			rate = (parseFloat(rate)/100).toFixed(2);
			var total = (parseFloat(rate) * parseFloat(this.state.totalLitters)).toFixed(2);
			
			this.setState({
				rate: rate,
				totalAmount: total,
			});
			
		}
		catch(error){ 
			console.log(error);
		}
	}
	
	handleSearch(e){
		try{
			var d = this.state.customers;
			var v = upperCase(e.target.value);
			var s = d.filter(function(obj){
				return( (upperCase(obj.customer_name).indexOf(v)>-1) || 
				(upperCase(obj.customer_address).indexOf(v)>-1) || 
				(upperCase(obj.customer_mobile).indexOf(v)>-1) );
			});
			
			this.setState({customerView:s});
		}
		catch(error){}
	}
	
	render(){

		return(
			<div className="container" >
			<div data-aos="fade" >
				
				<Spin spinning={this.state.showLoader} >
				
				<div className="card user-data-card">
					<div className="card-body">
						<form
							action=""
							method="post"
							encType="multipart/form-data"
							id="frmCollection_Entry"
							onSubmit={this.handleFormSubmit}
						>
						
						<input type="hidden" name="api" value={this.context.state.api} />
						<input type="hidden" name="i__shift" value={this.state.isMorning ? 'Morning' : 'Evening'} />
						<input type="hidden" name="i__customer" value={this.state.selectedCustomer.id} />
						
						<Row >
							<Col xs={3} >
								<label className="font-13" >
									Shift
								</label>
							</Col>
							<Col xs={9} >
								<Switch 
									checkedChildren="Morning"
									unCheckedChildren="Evening" 
									defaultChecked={this.state.isMorning}
									onChange={this.handleShiftChange} 
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									Date
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="date"
									name="i__entrtyDate"
									size="sm"
									defaultValue={momentDate((new Date()),'YYYY-MM-DD')}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15" >
							<Col xs={3} >
								<label className="font-13" >
									Code
								</label>
							</Col>
							<Col xs={9} >
								<InputGroup className="mb-3" size="" >
									<Form.Control
										type="number"
										name="i__customerCode"
										size="sm"
										className="no-arrow"
										defaultValue={this.state.selectedCustomer.customer_code}
										required
									/>
									<InputGroup.Prepend>
									  <Button
										type="button"
										size="sm"
										variant="primary"
										style={{height: '36px'}} 
										onClick={this.handleCustomerSearchClick} 
									  >
										<i className="icofont-search"></i>
									  </Button>
									</InputGroup.Prepend>
								  </InputGroup>
							</Col>
						</Row>
							
						<Row className="mt-12"  >
							<Col xs={3} >
								<label className="font-13" >
									Weight
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="number"
									name="i__weight"
									step="any"
									size="sm"
									value={this.state.totalWeight}
									onChange={this.handleWeightChange}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									Litters
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="number"
									name="i__litters"
									value={this.state.totalLitters}
									step="any"
									size="sm"
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									Fat (%)
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="text"
									name="i__fat"
									step="any"
									size="sm"
									value={this.state.totalFat}
									onChange={this.handleFatChange}
									onKeyPress={decimalKeyPress}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									LR (%)
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="text"
									name="i__lr"
									step="any"
									size="sm"
									value={this.state.totalLr}
									onChange={this.handleLrChange}
									onKeyPress={decimalKeyPress}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									SNF (%)
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="text"
									name="i__snf"
									step="any"
									size="sm"
									value={this.state.totalSnf}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									Rate
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="text"
									name="i__rate"
									step="any"
									size="sm"
									value={this.state.rate}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									Total
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="text"
									name="i__total"
									step="any"
									size="sm"
									value={this.state.totalAmount}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15" >						
							<Col md={12} >
								<Button
									type="submit"
									variant="success"
									size="md"
									block
									style={{width: '100%'}}
								>
									Save Data
								</Button>
							</Col>
						</Row>
							
						</form>
					</div>
				  </div>
				
				</Spin>
				
				<Modal show={this.state.showCustomerSerach} onHide={this.handleCustomerSearchClose} >
					<Modal.Header closeButton >
						Search
					</Modal.Header>
					<Modal.Body>
						<Form.Control
							size="sm"
							type="text"
							placeholder="Search by Name..."
							className="mb-10"
							onChange={this.handleSearch} 
						/>
						
						{this.state.customerView.map((item,i)=>{
							return <div className="card settings-card">
								<div className="card-body">
								  <div className="single-settings d-flex align-items-center justify-content-between">
									<div className="title">
										<div className="font-weight-600" >{item.customer_name}</div>
										<span>{item.customer_address}</span>
									</div>
									<div className="data-content" onClick={this.handleCustomerSelect.bind(this,item)} >
									  <div className="font-20"  >
										<i className="icofont-arrow-right"></i>
									  </div>
									</div>
								  </div>
								</div>
							  </div>;
						})
						}
					</Modal.Body>
				</Modal>
				 
			</div>
			</div>
		);
	}
	
}
export default AddCollectionEntry;
